import { PaymentAccordion } from './Accordion/Accordion';

export const PaymentTable = () => {
  return (
    <div>
      <PaymentAccordion />
    </div>
  );
};
